/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import {KTIcon} from '../../../helpers'

type Props = {
  className: string
}

const EmployeeOverviewWidget: React.FC<Props> = ({className}) => {
  return (
    <div className={`card ${className}`}>
      {/* begin::Header */}
      <div className='card-header border-0 pt-5 d-flex justify-content-between align-items-center'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bold fs-3 mb-1'>Employees Overview</span>
          <span className='text-muted mt-1 fw-semibold fs-7'>Summary of employee activity</span>
        </h3>
      </div>
      {/* end::Header */}

      {/* begin::Body */}
      <div className='card-body py-3'>
        <div className='table-responsive'>
          <table className='table align-middle gs-0 gy-3'>
            <thead>
              <tr>
                <th className='p-0 min-w-150px'>Employee</th>
                <th className='p-0 min-w-100px text-end'>Last Active</th>
                <th className='p-0 min-w-150px text-end'>Work Anniversary</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <div className='d-flex align-items-center'>
                    <div className='symbol symbol-50px me-2'>
                      <span className='symbol-label bg-light-success'>
                        <KTIcon iconName='user' className='fs-2x text-success' />
                      </span>
                    </div>
                    <div>
                      <a href='#' className='text-dark fw-bold text-hover-primary mb-1 fs-6'>
                        Azhar
                      </a>
                      <span className='text-muted fw-semibold d-block fs-7'>Software Engineer</span>
                    </div>
                  </div>
                </td>
                <td className='text-end'>
                  <span className='text-dark fw-bold d-block fs-7'>Today</span>
                </td>
                <td className='text-end'>
                  <span className='text-dark fw-bold d-block fs-7'>January 15, 2025</span>
                </td>
              </tr>
              <tr>
                <td>
                  <div className='d-flex align-items-center'>
                    <div className='symbol symbol-50px me-2'>
                      <span className='symbol-label bg-light-warning'>
                        <KTIcon iconName='user' className='fs-2x text-warning' />
                      </span>
                    </div>
                    <div>
                      <a href='#' className='text-dark fw-bold text-hover-primary mb-1 fs-6'>
                        Jane Smith
                      </a>
                      <span className='text-muted fw-semibold d-block fs-7'>Product Manager</span>
                    </div>
                  </div>
                </td>
                <td className='text-end'>
                  <span className='text-dark fw-bold d-block fs-7'>2 days ago</span>
                </td>
                <td className='text-end'>
                  <span className='text-dark fw-bold d-block fs-7'>August 23, 2024</span>
                </td>
              </tr>
              <tr>
                <td>
                  <div className='d-flex align-items-center'>
                    <div className='symbol symbol-50px me-2'>
                      <span className='symbol-label bg-light-danger'>
                        <KTIcon iconName='user' className='fs-2x text-danger' />
                      </span>
                    </div>
                    <div>
                      <a href='#' className='text-dark fw-bold text-hover-primary mb-1 fs-6'>
                        Alice Johnson
                      </a>
                      <span className='text-muted fw-semibold d-block fs-7'>UX Designer</span>
                    </div>
                  </div>
                </td>
                <td className='text-end'>
                  <span className='text-dark fw-bold d-block fs-7'>1 week ago</span>
                </td>
                <td className='text-end'>
                  <span className='text-dark fw-bold d-block fs-7'>July 23, 2024</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      {/* end::Body */}
    </div>
  )
}

export default EmployeeOverviewWidget
